import { useMutation, gql } from "@apollo/client";
import { toast } from "react-toastify";
import { ERROR_CODE_LIST as codeList } from "../utils/errCodes";
import { Helper } from "../utils";

const useGlobalMutation = (query, updateCache, handleError) => {
    const [mutationFunction, { loading, error }] = useMutation(gql`
        ${query}
    `);

    const submitMutation = async (variables, dataPath = "data", successMgs) => {
        try {
            const response = await mutationFunction({
                variables,
                update(cache, result) {
                    if (updateCache) {
                        updateCache(cache, result);
                    }
                },
            });
            const { data, errors } = response;

            if (Helper.accessNestedObject(data, dataPath) !== null ?? errors === undefined) {
                toast.success(successMgs || "Data Submitted Successfully");
                return null;
            } else {
                const errCode = errors?.[0]?.errcode;
                const errMessage = errCode ? codeList[errCode] : "Invalid Request";

                if (handleError) {
                    handleError({
                        errorCode: errCode,
                        message: errMessage,
                    });
                } else {
                    toast.error(errMessage);
                }

                return error;
            }
        } catch (error) {
            const errCode =
                error?.graphQLErrors[0]?.errcode || (codeList[error.message] && error.message);
            const errMessage =
                codeList[error?.graphQLErrors[0]?.errcode] ||
                codeList[error.message] ||
                error.message;

            if (handleError) {
                handleError({
                    errorCode: errCode,
                    message: errMessage,
                });
            } else {
                toast.error(errMessage);
            }

            return error;
        }
    };

    return { loading, error, submitMutation };
};

export default useGlobalMutation;
